var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandleAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6C15 7.39788 14.0439 8.57246 12.75 8.90549V11H14C15.1046 11 16 11.8954 16 13V13.8662C15.2559 14.0587 14.47 14.0328 13.7372 13.7885C12.6096 13.4126 11.3904 13.4126 10.2628 13.7885C9.53003 14.0328 8.74407 14.0587 8 13.8662V13C8 11.8954 8.89543 11 10 11H11.25V8.90549C9.95608 8.57246 9 7.39788 9 6C9 4.34315 12 2 12 2C12 2 15 4.34315 15 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 21.25C3.58579 21.25 3.25 21.5858 3.25 22C3.25 22.4142 3.58579 22.75 4 22.75H20C20.4142 22.75 20.75 22.4142 20.75 22C20.75 21.5858 20.4142 21.25 20 21.25H16V15.4016C15.0903 15.5701 14.1483 15.5067 13.2628 15.2115C12.4431 14.9383 11.5569 14.9383 10.7372 15.2115C9.85166 15.5067 8.90974 15.5701 8 15.4016V21.25H4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandleAlt1);
export default __webpack_public_path__ + "static/media/candle-alt-1.eb4b66e81b08f32b788a406a0289b2ed.svg";
export { ForwardRef as ReactComponent };